import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Chip,
  Paper,
} from "@mui/material";
import { AttachFile, Send } from "@mui/icons-material";
import BackBtn from "../../widgets/BackBtn";

const HelpFeedbackForm = () => {
  const [formData, setFormData] = useState({
    category: "",
    message: "",
    contactNumber: "",
    contactEmail: "",
    attachments: [],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter(
      (file) =>
        file.type.startsWith("image/") || file.type === "application/pdf"
    );

    setFormData((prev) => ({
      ...prev,
      attachments: [...prev.attachments, ...validFiles],
    }));
  };

  const removeAttachment = (index) => {
    setFormData((prev) => ({
      ...prev,
      attachments: prev.attachments.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log("Form submitted:", formData);
    // Reset form after submission
    setFormData({
      category: "",
      message: "",
      contactNumber: "",
      contactEmail: "",
      attachments: [],
    });
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <BackBtn />
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography
          variant="h5"
          gutterBottom
          sx={{ fontWeight: "bold", mb: 3 }}
        >
          Help & Feedback
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {/* Category Selection */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Category</InputLabel>
                <Select
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  label="Category"
                  required
                >
                  <MenuItem value="billing">Billing</MenuItem>
                  <MenuItem value="errors">Errors</MenuItem>
                  <MenuItem value="feedback">Feedback</MenuItem>
                  <MenuItem value="service request">Service Request</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Message Field */}
            <Grid item xs={12}>
              <TextField
                name="message"
                label="Message"
                value={formData.message}
                onChange={handleChange}
                multiline
                rows={6}
                fullWidth
                required
                variant="outlined"
              />
            </Grid>

            {/* Attachment Section */}
            <Grid item xs={12}>
              <input
                accept="image/*,.pdf"
                style={{ display: "none" }}
                id="attachment-input"
                multiple
                type="file"
                onChange={handleFileUpload}
              />
              <label htmlFor="attachment-input">
                <Button
                  variant="outlined"
                  component="span"
                  startIcon={<AttachFile />}
                >
                  Add Attachment
                </Button>
              </label>

              <Box sx={{ mt: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
                {formData.attachments.map((file, index) => (
                  <Chip
                    key={index}
                    label={file.name}
                    onDelete={() => removeAttachment(index)}
                    sx={{
                      backgroundColor: "action.selected",
                      borderRadius: 1,
                    }}
                  />
                ))}
              </Box>
              <Typography
                variant="caption"
                color="textSecondary"
                sx={{ mt: 1 }}
              >
                Supported formats: Images, PDF (Max 5MB each)
              </Typography>
            </Grid>

            {/* Contact Information */}
            <Grid item xs={12} md={6}>
              <TextField
                name="contactEmail"
                label="Email (Optional)"
                type="email"
                value={formData.contactEmail}
                onChange={handleChange}
                fullWidth
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                name="contactNumber"
                label="Phone (Optional)"
                value={formData.contactNumber}
                onChange={handleChange}
                fullWidth
                variant="outlined"
              />
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12} sx={{ textAlign: "right" }}>
              <Button
                type="submit"
                variant="contained"
                size="large"
                endIcon={<Send />}
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  fontWeight: "bold",
                  bgcolor: "primary.main",
                  "&:hover": { bgcolor: "primary.dark" },
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Container>
  );
};

export default HelpFeedbackForm;
